import React from 'react';
import { MTBFChartContainer } from '../charts';
import ChartTab from './ChartTab';

interface MTBFTabProps {
  machineSerialNo?: string;
  lineId?: string; // Line ID for line-level aggregated data
  shifts?: string[];
  syncGroup?: string;
  activeSubTab?: 'mtbf' | 'speed';
  onActiveSubTabChange?: (tab: 'mtbf' | 'speed') => void;
}

const MTBFTab: React.FC<MTBFTabProps> = ({ 
  machineSerialNo, 
  lineId,
  shifts, 
  syncGroup,
  activeSubTab,
  onActiveSubTabChange
}) => {
  // Suppress unused syncGroup warning
  React.useEffect(() => { void syncGroup; }, [syncGroup]);

  return (
    <ChartTab>
      <MTBFChartContainer 
        machineSerialNo={machineSerialNo}
        lineId={lineId}
        shifts={shifts}
        syncGroup={syncGroup}
        activeSubTab={activeSubTab}
        onActiveSubTabChange={onActiveSubTabChange}
      />
    </ChartTab>
  );
};

export default MTBFTab;
